import { ColDef } from 'ag-grid-community';

import {
  defaultColumnDefinition,
  defaultColumnDefinitionWithFilter,
} from '../../../shared/columnDefinitions';
import { EditableCheckboxCellRenderer } from '../../../shared/columnDefinitions/cellRenderers';
import { DatasetInstancesResponseData } from '../../../../../common/types';

export const getColumnDefinitions = ({
  additionalColumns,
  onSelectionChange,
  ToggleAllSelectionsHeader,
}: {
  additionalColumns: { name: string; id: string }[];
  onSelectionChange: (row: DatasetInstancesResponseData[number], isSelected: boolean) => void;
  ToggleAllSelectionsHeader: ColDef['headerComponent'];
}) => {
  return [
    {
      ...defaultColumnDefinition,
      headerComponent: ToggleAllSelectionsHeader,
      headerName: '',
      field: 'isSelected',
      colId: 'isSelected',
      width: 50,
      cellRenderer: EditableCheckboxCellRenderer,
      cellRendererParams: (params: { data: DatasetInstancesResponseData[number] }) => ({
        onValueChange: (newValue: boolean) => {
          onSelectionChange(params.data, newValue);
        },
      }),
      cellStyle: {
        textAlign: 'center',
      },
      pinned: 'left',
      lockPosition: true,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Instance',
      field: 'instanceIdentifier',
      pinned: 'left',
      lockPosition: true,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Sys Source ID',
      field: 'sysSourceId',
      sortable: true,
      filter: true,
      editable: false,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'App Code Created By',
      field: 'appCodeCreatedBy',
      sortable: true,
      filter: true,
      editable: false,
    },
    ...additionalColumns.map(({ name, id }) => ({
      ...defaultColumnDefinitionWithFilter,
      headerName: name,
      field: id,
      autoHeaderHeight: true,
    })),
  ];
};
